import makeStyles from "@mui/styles/makeStyles";
import { isEmpty } from "ramda";

export default makeStyles(
  (theme) => ({
    vertical: {
      display: "flex",
      justifyContent: "center",
      "& $root": {
        width: 288,
      },
      "& $rootBordered": {
        border: ({ inviteTheme }) =>
          !isEmpty(inviteTheme) ? `7px solid ${inviteTheme.invitationBorderColor}` : "7px solid #fff",
      },
    },
    root: {
      width: "100%",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      maxWidth: 778,
    },
    rootBordered: {
      boxShadow: "0 4px 9px 0 rgba(0,0,0,.25)",
      border: ({ inviteTheme }) =>
        !isEmpty(inviteTheme) ? `7px solid ${inviteTheme.invitationBorderColor}` : "7px solid #fff",
      [theme.breakpoints.up("mobile")]: {
        border: ({ inviteTheme }) =>
          !isEmpty(inviteTheme) ? `16px solid ${inviteTheme.invitationBorderColor}` : "16px solid #fff",
      },
      [theme.breakpoints.up("tablet")]: {
        border: ({ inviteTheme }) =>
          !isEmpty(inviteTheme) ? `20px solid ${inviteTheme.invitationBorderColor}` : "20px solid #fff",
      },
    },
    player: {
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
      position: "relative",
      overflow: "hidden",
    },
  }),
  { name: "PlayerContainer" },
);
